import * as React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Tag } from "../../api/classes";
import { DubitoSvc } from "src/api";

interface Props {
  open: boolean;
  element: Tag;
  onCancel: () => void;
  onEdit: () => void;
}
export default class EditTag extends React.Component<Props> {
  state = {
    open: this.props.open,
    tagName: this.props.element ? this.props.element.title : ""
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.props.onCancel();
  };
  handleApprove = () => {
    if (this.props.element) {
      this.editTag();
    } else {
      this.addTag();
    }
  };
  addTag = () => {
    if (this.state.tagName.length < 2) {
      return;
    }
    DubitoSvc.createTag({ title: this.state.tagName }).then(res => {
      this.props.onEdit && this.props.onEdit();
    });
  };
  editTag = () => {
    if (this.state.tagName.length < 2) {
      return;
    }
    DubitoSvc.editTag({
      tag_id: this.props.element.id,
      title: this.state.tagName
    }).then(res => {
      this.props.onEdit && this.props.onEdit();
    });
  };
  componentWillReceiveProps(next: Props) {
    this.setState({
      open: next.open,
      tagName: next.element ? next.element.title : ""
    });
  }
  render() {
    return (
      <div>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          style={{ minWidth: 500 }}
          maxWidth="sm"
          fullWidth
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            {this.props.element ? "Edit Tag" : "Add Tag"}
          </DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Tag Name"
              type="name"
              value={this.state.tagName}
              onChange={e => this.setState({ tagName: e.target.value })}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleApprove} color="primary">
              {this.props.element ? "Edit" : "Add"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/tags/edit.tsx